var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":"700px","value":_vm.visible},on:{"click:outside":function($event){return _vm.$emit('closedDialog')}}},[_c(_vm.componentByType,{tag:"component",attrs:{"existingValue":_vm.existingValue},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }